var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_2",
    transform: "translate(-371.000000, -28.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-outline",
    transform: "translate(371.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D2B7D",
    x: 3,
    y: 11,
    width: 18,
    height: 2,
    rx: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D2B7D",
    x: 3,
    y: 16,
    width: 18,
    height: 2,
    rx: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D2B7D",
    x: 3,
    y: 6,
    width: 18,
    height: 2,
    rx: 0.95
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.b1b587c14c7635857c727e7d27e3b75d.svg";
export { ForwardRef as ReactComponent };